import { Action, createReducer, on } from '@ngrx/store';

import { searchBarActions, selectDepartureDateAction } from '@shared/base-search-bar/store/actions/search-bar.actions';
import { loadSearchDataSuccessAction } from '@shared/base-search-bar/store/actions/storage.actions';

export const initialPickUpTimeState = '10:00';

const reducer = createReducer(
  initialPickUpTimeState,
  on(selectDepartureDateAction, (state, { date }) => state),
  on(searchBarActions.selectPickUpTimeAction, (state, { time }) => time),
  on(loadSearchDataSuccessAction, (state, { data }) => data ? data.pickUpTime : initialPickUpTimeState)
);

export function pickUpTimeReducer(state: string, action: Action): string {
  return reducer(state, action);
}
